
export const TOKEN_RETRIES = "retries"